import React from 'react';
import { CloseIcon } from '@chakra-ui/icons';
import { ReactComponent as MevoMascotIcon } from '../../../../assets/images/icons/rectangle-mevo.svg';
import { Box } from '../../../../components/UI-CHAKRA/Box';
import { Button } from '../../../../components/UI-CHAKRA/Button';
import { Flex } from '../../../../components/UI-CHAKRA/Flex';
import { IconButton } from '../../../../components/UI-CHAKRA/IconButton';
import { Text } from '../../../../components/UI-CHAKRA/Text';
import { SNCR_COLORS, SNCR_ERROR_CONTENT } from '../constants';
import { SncrErrorCode } from '../types';
import { APP_VIEWPORT_HEIGHT } from '../../../../helpers/embeddedViewport';

interface SncrErrorModalProps {
  code: SncrErrorCode;
  onDismiss(): void;
  onRetry(): void;
}

export function SncrErrorModal({ code, onDismiss, onRetry }: SncrErrorModalProps) {
  const content = SNCR_ERROR_CONTENT[code];
  const handleAction = content.action === 'retry' ? onRetry : onDismiss;

  return (
    <Flex
      position="fixed"
      top={0}
      left={0}
      width="100vw"
      height={APP_VIEWPORT_HEIGHT}
      zIndex={1500}
      bg={SNCR_COLORS.overlay}
      alignItems="center"
      justifyContent="center"
      padding="16px"
    >
      <Box bg="white" borderRadius="16px" padding="32px" width="100%" maxWidth="560px" position="relative">
        <IconButton
          aria-label="Fechar"
          variant="ghost"
          size="sm"
          icon={<CloseIcon boxSize="12px" color="primary.main" />}
          position="absolute"
          top="16px"
          right="16px"
          onClick={onDismiss}
        />

        <Flex justifyContent="center" mb="16px">
          <MevoMascotIcon style={{ width: '81px', height: '81px' }} />
        </Flex>

        <Text fontSize="20px" fontWeight={700} textAlign="start" mb="8px">
          {content.title}
        </Text>
        <Text fontSize="15px" color={SNCR_COLORS.textBody} textAlign="start" mb="16px">
          {content.description}
        </Text>

        <Button width="100%" size="lg" borderRadius="full" bg="primary.main" color="white" onClick={handleAction}>
          {content.actionLabel}
        </Button>
      </Box>
    </Flex>
  );
}
